import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import { getRatingOptions } from './utils';
import type { FilterState } from '@/features/filterSlice';
import { PriorityRatingType } from '@/features/types';

export const WildfirePriorityRatingFilter = (props: {
  control: Control<FilterState>;
}) => {
  const priorityRatings = getRatingOptions(PriorityRatingType);

  return (
    <Controller
      control={props.control}
      name="wildfirePriorityRatings"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label="Wildfire priority"
            placeholder="All levels"
            options={priorityRatings}
            onChange={onChange}
            onBlur={onBlur}
            value={priorityRatings.filter((c) => value.includes(c.value))}
            maxMenuHeight={150}
          />
        );
      }}
    />
  );
};
